// extracted by mini-css-extract-plugin
module.exports = {"address_box":"AddressBox_address_box__Egezm"};